import { StandardDividerProps } from '@brandfolder/react';
import { createResolvableComponent } from '../../create-resolvable-component';

export const BF_STANDARD_DIVIDER_COMPONENT = 'BF_STANDARD_DIVIDER_COMPONENT';
export type BFStandardDividerProps = StandardDividerProps;

const ResolvableStandardDivider = createResolvableComponent<BFStandardDividerProps>(BF_STANDARD_DIVIDER_COMPONENT);

export const BFStandardDivider = ResolvableStandardDivider;
